import React, { useState, useMemo } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';
import { usePermissionContext } from '../../contexts/PermissionContext';
import { io } from 'socket.io-client';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../../config/apiConfig';

const SOCKET_URL = API_BASE_URL.replace('/api', '');

export const MENU_GROUPS = [
  {
    items: [
      { key: 'dashboard', label: 'Dashboard', path: '/dashboard' },
      { key: 'accounting-dashboard', label: 'Accounting Dashboard', path: '/accounting-dashboard', module: 'Accounting Dashboard' },
      { key: 'account', label: 'Account', path: '/settings/account', module: 'Account' },
      { key: 'purchase-challan', label: 'Purchase Challan', path: '/purchase-challan', module: 'Purchase Challan' },
      { key: 'purchase-invoice', label: 'Purchase Invoice', path: '/purchase-invoice', module: 'Purchase Invoice' },
      { key: 'purchase-return', label: 'Purchase Return', path: '/purchase-return', module: 'PurchaseReturn' },
      { key: 'purchase-order-list', label: 'Product Order', path: '/purchase-order-list', module: 'Purchase Order' },
      { key: 'sales-challan', label: 'Sales Challan', path: '/sales-challan', module: 'Sales Challan' },
      { key: 'invoice', label: 'Sales Invoice', path: '/invoice', module: 'Sales Invoice' },
      { key: 'sales-return', label: 'Sales Return', path: '/sales-return', module: 'SalesReturn' },
    ]
  },
  {
    label: 'MASTER',
    items: [
      {
        key: 'master',
        label: 'MASTER',
        children: [
          { key: 'seller', label: 'Seller', path: '/seller', module: 'Seller' },
          { key: 'customer', label: 'Customer', path: '/customer', module: 'Customer' },
          { key: 'transporter', label: 'Transporter', path: '/transporter', module: 'Transporter' },
          { key: 'product', label: 'Product', path: '/product', module: 'Product' },
          { key: 'category', label: 'Category', path: '/category', module: 'Category' },
          { key: 'in-stock', label: 'In Stock', path: '/in-stock', module: 'InStock' },
          { key: 'out-stock', label: 'Out Stock', path: '/out-stock', module: 'OutStock' },
          { key: 'expenses', label: 'Expenses', path: '/expenses', module: 'Expense' },
          { key: 'voucher-list', label: 'Voucher Type', path: '/settings/voucher-type', module: 'VoucherType' },
          { key: 'bank', label: 'Bank', path: '/settings/bank', module: 'Bank' },
        ]
      }
    ]
  },
  {
    label: 'REPORT',
    items: [
      {
        key: 'report',
        label: 'REPORT',
        children: [
          { key: 'report-purchase', label: 'Purchase Invoice', path: '/report/purchase-invoice', module: 'Purchase Invoice' },
          { key: 'report-purchase-challan', label: 'Purchase Challan', path: '/report/purchase-challan', module: 'Purchase Challan' },
          { key: 'report-sale', label: 'Sale Invoice', path: '/report/sale-invoice', module: 'Sales Invoice' },
          { key: 'report-sale-challan', label: 'Sale Challan', path: '/report/sale-challan', module: 'Sales Challan' },
          { key: 'report-expense', label: 'Expense', path: '/report/expense', module: 'Expense' },
          { key: 'report-payment', label: 'Payment List', path: '/report/payment', module: 'VoucherType' },
          { key: 'report-gst', label: 'GST Report', path: '/report/gst-report', module: 'GST Report' },
        ]
      }
    ]
  },
  {
    label: 'OUTSTANDING',
    items: [
      {
        key: 'outstanding',
        label: 'OUTSTANDING',
        children: [
          { key: 'receivable', label: 'Receivable', path: '/outstanding/receivable', module: 'Sales Invoice' },
          { key: 'payable', label: 'Payable', path: '/outstanding/payable', module: 'Purchase Invoice' },
        ]
      }
    ]
  },
  {
    label: 'SUPPORT',
    items: [
      {
        key: 'chat-dropdown',
        label: 'SUPPORT',
        children: [
          { key: 'chat', label: 'Live Support', path: '/chat', module: 'Live Support' },
        ]
      }
    ]
  }
];

export const MENU_ITEMS = MENU_GROUPS.reduce((acc, curr) => {
  const flattenedItems = curr.items.reduce((itemAcc, item) => {
    if (item.children) {
      return [...itemAcc, item, ...item.children];
    }
    return [...itemAcc, item];
  }, []);
  return [...acc, ...flattenedItems];
}, []);



export const SETTINGS_ITEMS = [
  { key: 'company', label: 'Company', path: '/settings/company', module: 'Company' },
  { key: 'user', label: 'User', path: '/settings/user', module: 'User' },
  { key: 'grade', label: 'Grade', path: '/settings/grade', module: 'Grade' },
  { key: 'customer-type', label: 'Customer Type', path: '/settings/customer-type', module: 'CustomerType' },
  { key: 'seller-type', label: 'Seller Type', path: '/settings/seller-type', module: 'SellerType' },
  { key: 'transporter-type', label: 'Transporter Type', path: '/settings/transporter-type', module: 'TransporterType' },
  { key: 'invoice-name', label: 'Invoice Name', path: '/settings/invoice-name', module: 'InvoiceName' },
  { key: 'invoice-type', label: 'Invoice Type', path: '/settings/invoice-type', module: 'InvoiceType' },
  { key: 'payment-mode', label: 'Payment Mode', path: '/settings/payment-mode', module: 'PaymentMode' },
  { key: 'sale-type', label: 'Sale Type', path: '/settings/sale-type', module: 'SaleType' },
  { key: 'expense-type', label: 'Expense Type', path: '/settings/expense-type', module: 'ExpenseType' },
  { key: 'color', label: 'Color', path: '/settings/color', module: 'Color' },
  { key: 'invoice-copy', label: 'Invoice Copy', path: '/settings/invoice-copy', module: 'Invoice Copy' },
  { key: 'plan-payment', label: 'Plan Payments', path: '/settings/plan/payments', module: 'Plan Payment' },
  { key: 'plan', label: 'Plans', path: '/settings/plan', module: 'Plan' },
  { key: 'coupon', label: 'Coupons', path: '/settings/coupon', module: 'Coupon' },
  { key: 'account-group', label: 'Account Group', path: '/settings/account-group', module: 'AccountGroup' },
];

function AppLayout({ children, activeKey, activeTitle, onNavSelect, onLogout }) {
  const navigate = useNavigate();
  const { hasPermission, company, user, loading, appLoading, vouchers } = usePermissionContext();
  const isSuperAdmin = user?.role === 'SUPER_ADMIN';
  const isShreeja = (user?.companyId === null || user?.company_id === null) && !isSuperAdmin;
  const [unreadCount, setUnreadCount] = useState(0);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  // Use token as the reliable trigger for socket setup (works for all roles including SUPER_ADMIN)
  const [token, setToken] = useState(() => sessionStorage.getItem('token') || '');
  const socketRef = React.useRef(null);

  // Keep token state in sync when user logs in (PermissionContext sets user after login)
  React.useEffect(() => {
    const t = sessionStorage.getItem('token') || '';
    setToken(t);
  }, [user]);

  React.useEffect(() => {
    const token = sessionStorage.getItem('token');
    if (!token) {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
      return;
    }

    let isSubscribed = true;

    // Initial unread count fetch
    const fetchUnread = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/chat/unread-count`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        const data = await res.json();
        if (isSubscribed) setUnreadCount(data.count || 0);
      } catch (err) { /* silent */ }
    };
    fetchUnread();

    // Always create a fresh socket when token/user changes
    if (socketRef.current) {
      socketRef.current.disconnect();
      socketRef.current = null;
    }

    let socket;
    // Set a tiny delay to allow React Strict Mode's instant mount/unmount cycle to settle.
    // This prevents opening a connection and instantly closing it, which triggers the browser's
    // "WebSocket is closed before the connection is established" console warning.
    const socketTimer = setTimeout(() => {
      if (!isSubscribed) return;

      socketRef.current = io(SOCKET_URL, {
        path: '/api/socket.io',
        transports: ['websocket'],
        reconnectionAttempts: 10,
        reconnectionDelay: 1000,
      });
      socket = socketRef.current;

      socket.on('connect', handleConnect);
      socket.on('unreadUpdate', handleUnreadUpdate);
      socket.on('unreadCleared', handleUnreadCleared);
      socket.on('connect_error', (err) => {
        console.error('[SOCKET CLIENT] Socket connection error:', err);
      });
      socket.on('error', (err) => {
        console.error('[SOCKET CLIENT] Socket generic error:', err);
      });

      // If already connected by the time we attach handlers, identify immediately
      if (socket.connected) handleConnect();
    }, 50);

    // Identify this session with the server as soon as we connect
    const handleConnect = () => {
      console.log('[SOCKET CLIENT] Socket connected! Emitting identify with token:', token ? 'exists' : 'empty');
      if (socketRef.current) {
        socketRef.current.emit('identify', token);
      }
    };

    // Called whenever a new message is received for this user
    const handleUnreadUpdate = (data) => {
      console.log('[SOCKET CLIENT] Received unreadUpdate event:', data);
      if (!isSubscribed) return;
      const storedUser = JSON.parse(sessionStorage.getItem('user') || '{}');
      const currentUserId = storedUser?.id || storedUser?._id;

      console.log('[SOCKET CLIENT] comparing senderId:', data?.senderId, 'with currentUserId:', currentUserId);

      // Ignore events that we ourselves triggered
      if (data && String(data.senderId) === String(currentUserId)) {
        console.log('[SOCKET CLIENT] Message was sent by ourselves, ignoring toast.');
        return;
      }

      // Update badge count
      if (data && typeof data.totalUnreadCount !== 'undefined') {
        console.log('[SOCKET CLIENT] Setting unread badge count to:', data.totalUnreadCount);
        setUnreadCount(data.totalUnreadCount);
      } else {
        fetchUnread();
      }

      // Show toast if the user is not on the chat page OR if they are on the chat page but chatting with someone else
      const currentPath = window.location.pathname;
      const isOnChatPage = currentPath === '/chat' || currentPath.endsWith('/chat');
      const activeChatRoomId = sessionStorage.getItem('activeChatRoomId');

      let shouldShowToast = !isOnChatPage;
      if (isOnChatPage && data && data.roomId && activeChatRoomId && String(data.roomId) !== String(activeChatRoomId)) {
        shouldShowToast = true;
      }

      console.log('[SOCKET CLIENT] isOnChatPage:', isOnChatPage, 'activeChatRoomId:', activeChatRoomId, 'msgRoomId:', data?.roomId, 'shouldShowToast:', shouldShowToast);
      if (shouldShowToast && data && data.message) {
        let senderName = data.message.senderId?.userName ||
          data.message.senderId?.user_name ||
          'Someone';
        // Map SUPER_ADMIN to 'Support' as requested
        if (data.message.senderId?.role === 'SUPER_ADMIN' || senderName.toLowerCase() === 'super admin' || senderName.toLowerCase() === 'super_admin') {
          senderName = 'Technical Support';
        }

        const senderCompany = data.message.senderId?.companyName || null;
        const displayName = senderCompany
          ? `${senderName} (${senderCompany})`
          : senderName;

        console.log('[SOCKET CLIENT] Showing toast notification for message from:', displayName);
        toast.info(`✉️ You have message of ${displayName}`, {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          onClick: () => {
            const role = storedUser?.role;
            const rolePrefix = role === 'SUPER_ADMIN' ? '/super-admin' : (role === 'ADMIN' ? '/admin' : '/user');
            navigate(`${rolePrefix}/chat`, { state: { partner: data.message.senderId } });
          }
        });
      }
    };

    const handleUnreadCleared = () => {
      console.log('[SOCKET CLIENT] Received unreadCleared event');
      if (isSubscribed) fetchUnread();
    };

    return () => {
      isSubscribed = false;
      clearTimeout(socketTimer);
      if (socket) {
        socket.off('connect', handleConnect);
        socket.off('unreadUpdate', handleUnreadUpdate);
        socket.off('unreadCleared', handleUnreadCleared);
        socket.disconnect();
      }
      socketRef.current = null;
    };
  }, [token]);

  const filteredItems = useMemo(() => {
    const userRole = user?.role;

    // Calculate permitted settings that should be moved from Settings to Main Sidebar
    const permittedSettings = SETTINGS_ITEMS.filter(item => {
      if (userRole === 'SUPER_ADMIN') return true;
      // COMPANY_ADMIN should always see Plans, Coupons, and Plan Payments to view their subscription status
      if ((userRole === 'COMPANY_ADMIN' || userRole === 'ADMIN') && (item.module === 'Plan' || item.module === 'Coupon' || item.module === 'Plan Payment')) {
        return true;
      }
      return hasPermission(item.module, 'view');
    });

    let baseGroups = [];

    if (isSuperAdmin || isShreeja) {
      baseGroups = [
        {
          items: [
            { key: 'dashboard', label: 'Dashboard', path: '/dashboard', module: 'Dashboard' },
            { key: 'company', label: 'Company List', path: '/settings/company', module: 'Company' },
            { key: 'format', label: 'Format', path: '/settings/format', module: 'Company' },
            { key: 'user', label: 'User', path: '/settings/user', module: 'User' },
            { key: 'plan-payment', label: 'Plan Payments', path: '/settings/plan/payments', module: 'Plan Payment' },
            { key: 'plan', label: 'Plans', path: '/settings/plan', module: 'Plan' },
            { key: 'coupon', label: 'Coupons', path: '/settings/coupon', module: 'Coupon' },
            { key: 'chat', label: 'Live Support', path: '/chat', module: 'Live Support' }
          ]
        }
      ];
    } else {
      // Deep-clone MENU_GROUPS so splice never mutates the original constant across re-renders
      baseGroups = JSON.parse(JSON.stringify(MENU_GROUPS));

      // Add Voucher Type group if permission exists - Inserted at index 3 (after Report)
      if (hasPermission('VoucherType', 'view') && vouchers && vouchers.length > 0) {
        const defaultTypes = ["Kasar Payment", "Cash Receipt", "cash payment", "Bank Receipt", "Bank Payment"];

        const sortedVouchers = [...vouchers].sort((a, b) => {
          const aIndex = defaultTypes.findIndex(d => d.toLowerCase() === (a.voucherTypeName || '').toLowerCase());
          const bIndex = defaultTypes.findIndex(d => d.toLowerCase() === (b.voucherTypeName || '').toLowerCase());
          if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
          if (aIndex !== -1) return -1;
          if (bIndex !== -1) return 1;
          return (a.voucherTypeName || '').localeCompare(b.voucherTypeName || '');
        });

        baseGroups.splice(3, 0, {
          label: 'VOUCHER TYPE',
          items: [
            {
              key: 'voucher-group',
              label: 'Voucher Type',
              module: 'VoucherType',
              children: sortedVouchers.map(v => ({
                key: `v-${v._id}`,
                label: v.voucherTypeName,
                path: `/voucher-entry/${v._id}`,
                module: 'VoucherType'
              }))
            }
          ]
        });
      }
    }

    return baseGroups
      .map(group => {
        const filteredGroupItems = group.items
          .map(item => {
            // Handle item with children (standard)
            if (item.children) {
              const visibleChildren = item.children.filter(child => {
                if (userRole === 'SUPER_ADMIN') return true;

                // Chat is default/visible for all users and company admins
                if (child.key === 'chat') {
                  return true;
                }
                
                // Allow dynamic vouchers if they have VoucherType permission
                if (child.key.startsWith('v-') && hasPermission('VoucherType', 'view')) {
                    return true;
                }

                // Strict dynamic permission check
                return child.module ? hasPermission(child.module, 'view') : true;
              });

              if (visibleChildren.length > 0) {
                // If it's the chat dropdown, add the unread badge to the parent
                if (item.key === 'chat-dropdown' && unreadCount > 0) {
                  return { ...item, children: visibleChildren, badge: unreadCount };
                }
                return { ...item, children: visibleChildren };
              }
              return null;
            }

            // Handle standalone item
            if (userRole === 'SUPER_ADMIN') {
                return item;
            }

            if (item.key === 'chat') {
              // Chat is default/visible for all users and company admins
              return unreadCount > 0 ? { ...item, badge: unreadCount } : item;
            }

            // Strict dynamic permission check
            if (item.module) {
                if (hasPermission(item.module, 'view')) {
                    return item;
                }
                return null; // Deny if permission fails
            }

            return item; // If no module defined, allow (mostly for generic non-protected items if any)
          })
          .filter(Boolean);

        return { ...group, items: filteredGroupItems };
      })
      .filter(group => group.items.length > 0);
  }, [hasPermission, unreadCount, vouchers, company, user, isSuperAdmin, isShreeja]);



  const filteredSettingsItems = useMemo(() => {
    return SETTINGS_ITEMS.filter(item => {
      // Super Admin sees everything in Settings
      if (isSuperAdmin) return true;

      // Strict dynamic permission check
      if (item.module) {
          return hasPermission(item.module, 'view');
      }
      return true;
    });
  }, [hasPermission, company, user, isSuperAdmin, isShreeja]);


  return (
    <div className="app-shell">
      <Sidebar
        companyName={isSuperAdmin ? "Super Admin" : (company?.companyName || "Asencia")}
        companyLogo={isSuperAdmin ? null : (company?.companyLogoImage)}
        isSuperAdmin={isSuperAdmin}
        isOpen={sidebarOpen}
        isCollapsed={sidebarCollapsed}
        onToggleCollapsed={() => setSidebarCollapsed((v) => !v)}
        onClose={() => setSidebarOpen(false)}
        items={filteredItems}
        settingsItems={filteredSettingsItems}
        activeKey={activeKey}
        onSelect={(key) => {
          // Find the item to get its path
          const allItems = [...filteredItems.flatMap(g => g.items), ...filteredSettingsItems];
          // Also check nested children
          const findDeep = (items, key) => {
            for (const item of items) {
              if (item.key === key) return item;
              if (item.children) {
                const found = findDeep(item.children, key);
                if (found) return found;
              }
            }
            return null;
          };

          const foundItem = findDeep(allItems, key);
          if (foundItem && foundItem.path) {
            onNavSelect(foundItem.path);
          } else {
            // Fallback for items where key might be the path
            onNavSelect(key);
          }
          setSidebarOpen(false);
        }}
      />

      <div className="app-shell__content">
        <Header
          title={activeTitle || ''}
          onOpenSidebar={() => setSidebarOpen(true)}
          profile={{
            name: user?.user_name || user?.userName || user?.name || 'User',
            role: user?.role || 'Profile',
            image: user?.userProfile || user?.user_profile || ''
          }}
          onLogout={onLogout}
        />
        <main className="app-shell__main" role="main">
          {children}
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default AppLayout;
